var _path, _circle, _path2, _path3, _path4, _path5, _path6, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _ellipse, _circle8, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 600,
    viewBox: "0 0 900 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h900v600H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 450.067,
    cy: 301.664,
    r: 172.138,
    fill: "#666AF6",
    stroke: "#666AF6",
    strokeWidth: 29.873,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m468.284 237.912-36.431 127.509m-41.007-45.545-36.416-36.417 36.416-36.436m118.411 109.289 36.436-36.436-36.436-36.417",
    stroke: "#fff",
    strokeWidth: 23.898,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170.914 268h51.782m0-25.89h-34.521m34.521-25.892h-8.63",
    stroke: "#E1E4E5",
    strokeWidth: 11.867,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M594.607 515.943c-6.788 4.673-17.155 1.403-17.155 1.403s.644-10.845 7.436-15.514c6.788-4.673 17.151-1.407 17.151-1.407s-.645 10.845-7.432 15.518z",
    fill: "url(#a)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M755.4 254.917c7.695-5.27 8.455-17.55 8.455-17.55s-11.717-3.728-19.409 1.549c-7.695 5.27-8.459 17.543-8.459 17.543s11.718 3.728 19.413-1.542z",
    fill: "url(#b)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M201.255 398.437c13.308-11.498 12.142-34.669 12.142-34.669s-22.742-4.513-36.043 6.996c-13.307 11.498-12.149 34.657-12.149 34.657s22.743 4.514 36.05-6.984z",
    fill: "url(#c)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 10.466,
    transform: "matrix(-1 0 0 1 387.431 519.037)",
    fill: "#E1E4E5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 8.395,
    transform: "matrix(-1 0 0 1 687.054 267.498)",
    fill: "#E1E4E5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 5.373,
    transform: "matrix(-1 0 0 1 689.158 128.903)",
    fill: "#E1E4E5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 5.373,
    transform: "matrix(-1 0 0 1 509.636 519.339)",
    fill: "#E1E4E5"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 5.373,
    transform: "matrix(-1 0 0 1 641.249 486.975)",
    fill: "#E1E4E5"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 11.149,
    transform: "matrix(-1 0 0 1 225.216 438.811)",
    fill: "#E1E4E5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 8.576,
    ry: 6.861,
    transform: "matrix(-1 0 0 1 300.318 492.778)",
    fill: "#E1E4E5"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(0 1 1 0 555.862 94.927)",
    fill: "#E1E4E5",
    r: 8.955
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M722.399 297.13h.224c1.329 18.825 15.328 19.115 15.328 19.115s-15.437.301-15.437 22.052c0-21.751-15.438-22.052-15.438-22.052s13.994-.29 15.323-19.115zm-70.883-117.516h.225c1.328 18.825 15.328 19.114 15.328 19.114s-15.438.302-15.438 22.053c0-21.751-15.437-22.053-15.437-22.053s13.994-.289 15.322-19.114zM353.331 71h.162c.958 13.774 11.054 13.987 11.054 13.987s-11.133.22-11.133 16.136c0-15.916-11.132-16.136-11.132-16.136s10.091-.213 11.049-13.987zM177.262 303.361h.162c.958 13.775 11.054 13.987 11.054 13.987s-11.133.22-11.133 16.136c0-15.916-11.132-16.136-11.132-16.136s10.091-.212 11.049-13.987z",
    fill: "#E1E4E5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M666.147 408.641h3.8a1.66 1.66 0 0 1 1.659 1.659v3.8a1.66 1.66 0 0 1-1.659 1.659h-3.8a1.666 1.666 0 0 1-1.659-1.659v-3.8a1.656 1.656 0 0 1 1.659-1.659zm13.176 0h3.8c.911 0 1.659.748 1.659 1.659v3.8a1.66 1.66 0 0 1-1.659 1.659h-3.8a1.666 1.666 0 0 1-1.659-1.659v-3.8c0-.911.748-1.659 1.659-1.659zm13.185 0h3.8c.911 0 1.659.748 1.659 1.659v3.8a1.66 1.66 0 0 1-1.659 1.659h-3.8a1.665 1.665 0 0 1-1.659-1.659v-3.8a1.655 1.655 0 0 1 1.659-1.659zm13.175 0h3.801c.911 0 1.658.748 1.658 1.659v3.8a1.66 1.66 0 0 1-1.658 1.659h-3.801a1.667 1.667 0 0 1-1.666-1.659v-3.8a1.677 1.677 0 0 1 1.666-1.659zm13.177 0h3.8c.919 0 1.667.748 1.667 1.659v3.8c0 .919-.748 1.659-1.667 1.659h-3.8a1.666 1.666 0 0 1-1.659-1.659v-3.8c0-.911.748-1.659 1.659-1.659zm-39.054 14.368h3.8c.912 0 1.659.747 1.659 1.658v3.809c0 .911-.747 1.658-1.659 1.658h-3.8a1.66 1.66 0 0 1-1.659-1.658v-3.801a1.657 1.657 0 0 1 1.659-1.666zm13.176 0h3.8c.912 0 1.659.747 1.659 1.658v3.809c0 .911-.747 1.658-1.659 1.658h-3.8a1.665 1.665 0 0 1-1.659-1.658v-3.801a1.657 1.657 0 0 1 1.659-1.666zm13.177 0h3.8c.919 0 1.667.747 1.667 1.658v3.809c0 .911-.748 1.658-1.667 1.658h-3.8a1.665 1.665 0 0 1-1.659-1.658v-3.801c0-.919.748-1.666 1.659-1.666zm-13.651-29.803h3.8c.911 0 1.659.748 1.659 1.659v3.8a1.66 1.66 0 0 1-1.659 1.659h-3.8a1.665 1.665 0 0 1-1.659-1.659v-3.8a1.655 1.655 0 0 1 1.659-1.659zm13.175 0h3.801c.911 0 1.658.748 1.658 1.659v3.8a1.66 1.66 0 0 1-1.658 1.659h-3.801a1.667 1.667 0 0 1-1.666-1.659v-3.8a1.677 1.677 0 0 1 1.666-1.659zM224.567 126.579h3.8a1.66 1.66 0 0 1 1.659 1.658v3.801a1.66 1.66 0 0 1-1.659 1.658h-3.8a1.665 1.665 0 0 1-1.659-1.658v-3.801a1.655 1.655 0 0 1 1.659-1.658zm13.176 0h3.8c.911 0 1.659.747 1.659 1.658v3.801a1.66 1.66 0 0 1-1.659 1.658h-3.8a1.665 1.665 0 0 1-1.659-1.658v-3.801c0-.911.748-1.658 1.659-1.658zm13.184 0h3.801c.911 0 1.658.747 1.658 1.658v3.801a1.66 1.66 0 0 1-1.658 1.658h-3.801a1.664 1.664 0 0 1-1.658-1.658v-3.801a1.654 1.654 0 0 1 1.658-1.658zm13.176 0h3.8c.911 0 1.659.747 1.659 1.658v3.801a1.66 1.66 0 0 1-1.659 1.658h-3.8a1.666 1.666 0 0 1-1.666-1.658v-3.801a1.675 1.675 0 0 1 1.666-1.658zm13.177 0h3.8c.919 0 1.667.747 1.667 1.658v3.801c0 .918-.748 1.658-1.667 1.658h-3.8a1.665 1.665 0 0 1-1.659-1.658v-3.801c0-.911.748-1.658 1.659-1.658zm-39.054 14.367h3.8c.911 0 1.659.748 1.659 1.659v3.808c0 .911-.748 1.659-1.659 1.659h-3.8a1.66 1.66 0 0 1-1.659-1.659v-3.8a1.658 1.658 0 0 1 1.659-1.667zm13.176 0h3.8c.911 0 1.659.748 1.659 1.659v3.808c0 .911-.748 1.659-1.659 1.659h-3.8a1.666 1.666 0 0 1-1.659-1.659v-3.8a1.657 1.657 0 0 1 1.659-1.667zm13.177 0h3.8c.919 0 1.666.748 1.666 1.659v3.808c0 .911-.747 1.659-1.666 1.659h-3.8a1.666 1.666 0 0 1-1.659-1.659v-3.8c0-.919.748-1.667 1.659-1.667zm-13.652-29.802h3.801c.911 0 1.658.747 1.658 1.658v3.801c0 .919-.747 1.658-1.658 1.658h-3.801a1.664 1.664 0 0 1-1.658-1.658v-3.801a1.654 1.654 0 0 1 1.658-1.658zm13.176 0h3.8c.911 0 1.659.747 1.659 1.658v3.801a1.66 1.66 0 0 1-1.659 1.658h-3.8a1.666 1.666 0 0 1-1.666-1.658v-3.801a1.675 1.675 0 0 1 1.666-1.658z",
    fill: "#E1E4E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 568.167,
    y1: 531.275,
    x2: 621.602,
    y2: 474.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 782.342,
    y1: 233.222,
    x2: 701.132,
    y2: 266.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 247.163,
    y1: 352.101,
    x2: 102.067,
    y2: 432.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationCode);
export default __webpack_public_path__ + "static/media/illustration-code.2a403d2e61e0fd79bf511a1c3e973853.svg";
export { ForwardRef as ReactComponent };